<!-- FILE -->
<div class="upload-file-container">
  <div class="file-content" *ngIf="!(postedFile && tool.data) else fileExisting" fileDropZone
    (fileDrop)="onFileDropped($event)">
    <p class="text-drag-file"> Arrastra el archivo aquí</p>
    <p class="text-drag-file divisor">— o —</p>
    <input type="file" class="file-uploader" (change)="onFileSelected($event)" #fileUpload>
    <button class="upload-file-btn" (click)="fileUpload.click()">Seleccionar archivo de tu ordenador</button>
  </div>
  <a class="btn-transparent" [href]="downloadTemplate" download="translation_template.json">Descargar plantilla</a>
  <ng-template #fileExisting>
    <div class="file-content active">
      <div class="file-box">
        <span>{{ postedFile.name }}</span>
        <button class="element-action-btn" (click)="deleteDroppedFile()">
          <img id="delete" alt="">
        </button>
      </div>
      <div class="jsonviewer-wrapper" *ngIf="tool.fileData">
        <ngx-json-viewer *ngIf="tool.fileData" [json]="tool.fileData" [expanded]="false"></ngx-json-viewer>
      </div>
    </div>
  </ng-template>
</div>